import UploadOss from './UploadOss.vue'

export default UploadOss
